module.exports = __webpack_public_path__ + "img/contingent-image6.72061a50.jpg";